import React, { lazy } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

import { withAuth } from 'utils';
import { AuthLayout, ErrorLayout, MainLayout } from 'layouts';
//import Dashboard from './views/Dashboard';
import GroupList from './views/GroupList';
import JobList from './views/JobList';
import JobForm from './views/JobForm';
import BatchAdd from './views/BatchAdd';
import Changelist from './views/Changelist';
import FieldData from './views/FieldData';
import DailyReports from './views/DailyReports';
import TrackerReports from './views/TrackerReports';
import ExtraReports from './views/ExtraReports';
import OrderPrices from './views/OrderPrices';
import Systems from './views/Systems';
import Cloudboard from './views/Cloudboard';
import IpCount from './views/IpCount';
import Settings from './views/Settings';
import Testing from './views/Testing';

const Login = lazy(() => import('views/Login'));
const Logout = lazy(() => import('views/Logout'));
const Errors = lazy(() => import('views/Errors'));
//const Error500 = lazy(() => import('views/Error500'));

const withLoggedIn = withAuth(['user', 'admin']);
const withAdmin = withAuth(['admin']);

const routes = (
  <Routes>
    <Route path="/" element={<Outlet />}>
      <Route index element={<Navigate to="/groups" />} />

      <Route path="errors" element={<ErrorLayout />}>
        <Route path="*" element={<Errors />} />
      </Route>

      <Route path="auth" element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
        <Route path="logout" element={<Logout />} />
        <Route path="*" element={<Navigate to="/errors/404" />} />
      </Route>

      <Route path="*" element={withLoggedIn(MainLayout)()}>
        <Route path="groups" element={<GroupList />} />
        <Route path="systems" element={withAdmin(Systems)()} />
        <Route path="cloudboard" element={withAdmin(Cloudboard)()} />
        <Route path="ipcount" element={<IpCount />} />
        <Route path="settings" element={<Settings />} />
        <Route path="testing" element={withAdmin(Testing)()} />

        <Route path="jobs" element={<Outlet />}>
          <Route index element={<JobList />} />
          <Route path="new" element={withAdmin(JobForm)()} />
          <Route path="batchadd" element={withAdmin(BatchAdd)()} />
          <Route path="batchedit" element={withAdmin(BatchAdd)()} />
          <Route path=":jobId/edit" element={<JobForm />} />
          <Route path="changelist" element={<Changelist />} />
          <Route path="devusage" element={<FieldData />} />
          <Route path="ipuauv" element={<FieldData />} />
        </Route>

        <Route path="reports" element={<Outlet />}>
          <Route path="jobdaily"  element={<DailyReports />} />
          <Route path="trackers" element={<TrackerReports />} />
          <Route path="extra/order-prices" element={withAdmin(OrderPrices)()} />
          <Route path="extra/*" element={<ExtraReports />} />
        </Route>

        <Route path="*" element={<Navigate to="/errors/404" />} />
      </Route>
    </Route>
  </Routes>
);

export default routes;
